import React, { useEffect, useState } from 'react'
import swal from 'sweetalert2';
import { getSoldPlayer, getUnAssignedPlayers } from '../api/playerAPI';
import PlayerTable from './PlayerTable';

const SoldPlayer = () => {

    const [playerList,          setPlayerList]          = useState([]);
    const [loading,             setLoading]             = useState(false);

    useEffect(() => {
        fetchSoldPlayers();
    }, [])

    const fetchSoldPlayers = async () => {
        try {
            setLoading(true);
            const players = await getSoldPlayer();
            setPlayerList(players);             
            setLoading(false);
        } catch (error) {
            setLoading(false);
            swal.fire({
                icon      : 'error',
                titleText : error.message
            })  
        }
    }

    return (
        <>
            <PlayerTable
                from='sold'
                playerList={playerList}
                loading={loading}
            />
        </>
    )
}

export default SoldPlayer